<template>
  <div class="table_wrap">
    <div class="total_length">총 {{ this.paginationData.total }}건</div>
    <el-table class="list-table" header-cell-class-name="list-header" style="width: 100%;" :data="utilityData" empty-text="데이터가 없습니다.">
      <el-table-column label="No" type="index" :index="tableIdx" minWidth="80" width="80" class-name="num text-center"></el-table-column>
      <el-table-column label="회원상태" class-name="text-center">
        <template v-slot="{ row }">
          {{ returnMemberStatus(row.mb_is_use) }}
        </template>
      </el-table-column>
      <el-table-column label="아이디" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.mb_id }}
        </template>
      </el-table-column>
      <el-table-column label="닉네임" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.mb_nick }}
        </template>
      </el-table-column>
      <el-table-column label="이름" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.mb_name }}
        </template>
      </el-table-column>
      <el-table-column label="매칭일" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.created_at }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins"

export default {
  name: "UtilityListPubCurrentLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {};
  },
  props: {
    utilityData: {
      default: () => {
        return [];
      },
    },
    utilTopCategory: {
      default: () => {
        return [];
      },
    },
    utilBottomCategory: {
      default: () => {
        return [];
      },
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      },
    },
  },
  data() {
    return {};
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    tableIdx(index) {
      return (
        this.paginationData.total -
        index -
        (this.paginationData.page - 1) * this.paginationData.size
      );
    },
    returnMemberStatus(value) {
      if (value == 0) {
        return '탈퇴회원'
      } else if (value == 1) {
        return '활동'
      } else if (value == 2) {
        return '휴면회원'
      }
    },
    moveDetail(idx, uu_idx){
      this.$router.push(`/nticket/utility/${idx}/detail/${uu_idx}`);
    }
  },
  watch: {},
};
</script>

<style scoped></style>
